import React from 'react';
import { prop } from 'ramda';

import * as hooks from './hooks';
import { Tags } from './components/Tags';
import { Emitter } from './components/Emitter';
import { Conditions } from './components/Conditions';
import { useAppSelector } from 'js/store/hooks';
import { WrapperConditions } from './components/WrapperConditions';

export const TagManager = ({ isWrapper }) => {
    const tags = useAppSelector(prop('tags'));

    hooks.useCodeInsertions();

    if (!tags.length) {
        return null;
    }

    return (
        <Emitter>
            <Tags />
            {isWrapper ? <WrapperConditions /> : <Conditions />}
        </Emitter>
    );
};
